export default { sha: '1310ff2ee2cb9dfd70075cd5f7f0dbc572cb25ca', buildNumber: 'undefined' }
